





































import Vue from "vue";
export default Vue.extend({
  methods: {
    startOver(): void {
      location.reload();
    },
  },
});
